import { onDomReady } from '@js/src/helpers';
import { createApp } from 'vue'
import Filters from '@js/src/components/Filters.vue'

onDomReady(function () {
    createApp(Filters)
        .mount('#filters');
});
